export const enum Position {
    TOP,
    BOTTOM,
    LEFT,
    RIGHT,
    CENTER,
}
